import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';

import { ZardButtonComponent } from '@solvace/zard/shared/components/button';
import { ZardDialogRef } from '@solvace/zard/shared/components/dialog/dialog-ref';
import { Z_MODAL_DATA } from '@solvace/zard/shared/components/dialog/dialog.service';

export interface SvzAlertDialogData {
  text: string;
  title?: string;
  buttonText?: string;
  accentColor?: string;
}

@Component({
  selector: 'svz-alert-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ZardButtonComponent],
  templateUrl: './svz-alert-dialog.component.html',
})
export class SvzAlertDialogComponent {
  private readonly dialogRef = inject(ZardDialogRef<SvzAlertDialogComponent, void>);
  private readonly data = inject<SvzAlertDialogData>(Z_MODAL_DATA);

  protected readonly title = this.data?.title ?? 'Alerta';
  protected readonly text = this.data?.text;
  protected readonly buttonText = this.data?.buttonText ?? 'OK';
  protected readonly accentColor = this.data?.accentColor ?? '#9a2e23';

  @HostBinding('class.svz-alert-dialog') protected readonly hostClass = true;

  @HostBinding('style.--svz-alert-color')
  protected get alertColorVar(): string {
    return this.accentColor;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
